module.exports = __webpack_public_path__ + "static/media/rio-raphael-nogueira.19ec0d4c.jpg";